export default __webpack_public_path__ + "static/bbbc-landing-faded-bg-c0ce955b12d1a1392cc7a722dc91a731.webp";